import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function AddKit() {
	const [name, setName] = useState("");
	const [notes, setNotes] = useState("");
	const [color, setColor] = useState("");
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	async function handleSubmit(e) {
		e.preventDefault();
		setError(null);

		if (!name.trim()) {
			setError("Kit name is required");
			return;
		}

		setLoading(true);

		const { error: insertError } = await supabase
			.from("kits")
			.insert([{ name, notes, color }]);

		setLoading(false);

		if (insertError) {
			setError("Failed to add kit");
			console.error(insertError);
		} else {
			navigate("/kits");
		}
	}

	if (loading) {
		return (
			<div className="loading">
				<div>
					<i className="pi pi-spin pi-spinner"></i>
				</div>
			</div>
		);
	}

	return (
		<div className="main add-item-page">
			<h1 className="add-item__title">Add New Kit</h1>

			{error && <div className="add-item__error">{error}</div>}

			<form onSubmit={handleSubmit} className="add-item__form">
				<div>
					<div className="form-group">
						<label>Name (required): </label>
						<input
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							required
						/>
					</div>
				</div>
				<div>
					<div className="form-group">
						<label>Color:</label>
						<input
							type="text"
							value={color}
							onChange={(e) => {
								let value = e.target.value.trim();
								if (value && !value.startsWith("#")) {
									value = "#" + value;
								}
								setColor(value);
							}}
						/>
					</div>
				</div>

				<div className="form-group">
					<label>Notes: </label>
					<textarea
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
					/>
				</div>

				<div className="form-actions">
					<button
						type="submit"
						disabled={loading}
						className="button green"
					>
						{loading ? (
							"Adding..."
						) : (
							<>
								<i className="pi pi-plus"></i>Add Kit
							</>
						)}
					</button>
					<button
						type="button"
						onClick={() => navigate("/kits")}
						className="button"
					>
						Cancel
					</button>
				</div>
			</form>
		</div>
	);
}
